import React from 'react';
import { Dropdown } from 'react-bootstrap'

import UsIcon from '../../../../icon/us.svg'
import styles from './styles.module.scss'

const Language: React.FC = () => {
  
  return (
    <Dropdown autoClose="outside">
      <Dropdown.Toggle className="p-0 mx-1" variant="white" id="dropdown-basic">
        <img src={UsIcon} className={styles.selectLangues} alt="US" width={18} height={14} />
        <span className={styles.language}>English</span>
      </Dropdown.Toggle>

      <Dropdown.Menu align='end'>
        <Dropdown.Item eventKey="1">
          <img src={UsIcon} alt="US" width={18} height={14} /> 
          <span className={styles.language}>English</span>
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default Language
